<template>
  <page-background>
    <template v-slot>
      <auth-card class="recoverPasswordView">
        <div>
          <h1 class="appContent__title">{{ $t('pageNames.' + $route.name) }}</h1>
          <recover-password-form />
        </div>
      </auth-card>
    </template>
  </page-background>
</template>

<script>
import AuthCard from '@/components/auth/AuthCard'
import RecoverPasswordForm from '@/components/auth/RecoverPasswordForm'

export default {
  name: "RecoverPassword",
  components: {
    AuthCard,
    RecoverPasswordForm
  }
}
</script>

<style lang="scss" scoped>
$c: '.recoverPasswordView';

#{$c} {
  @include respond-above(xs) {
    min-height: calc(100vh - 125px);
  }

  div {
    padding: 92px 36px 20px 36px;
    @include respond-above(xs) {
      padding: 72px 72px 20px 72px;
    }
  }
  h1 {
    padding-top: 30px;
    padding-bottom: 25px;
    word-break: break-word;
    text-align: center;
    @include respond-above(xs) {
      max-width: 300px;
    }
  }
}
</style>